import { render } from "./AlphaX.vue?vue&type=template&id=ad1fa794"
import script from "./AlphaX.vue?vue&type=script&lang=js"
export * from "./AlphaX.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/AlphaX.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad1fa794"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad1fa794', __exports__)) {
    api.reload('ad1fa794', __exports__)
  }
  
  module.hot.accept("./AlphaX.vue?vue&type=template&id=ad1fa794", () => {
    api.rerender('ad1fa794', render)
  })

}


export default __exports__